var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card-dialog",
    {
      attrs: {
        value: _vm.value,
        title: _vm.isEditing ? _vm.$t("title.edit") : _vm.$t("title.create"),
        width: 848,
        "content-class": "capture-record-dialog",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "dialog-action",
                {
                  attrs: { "data-testid": "cancel_button" },
                  on: { click: _vm.close },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("button.cancel")) + "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "dialog-action",
                {
                  attrs: {
                    disabled: _vm.saving || !_vm.valid,
                    "data-testid": "save_button",
                  },
                  on: { click: _vm.save },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.saving
                          ? _vm.$t("button.saving")
                          : _vm.isEditing
                          ? _vm.$t("button.save")
                          : _vm.$t("button.create")
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("div", { staticClass: "editor-body" }, [
            _c(
              "div",
              { staticClass: "editor-form" },
              [
                _c(
                  "form-field",
                  {
                    attrs: {
                      label: _vm.$t("field.date"),
                      required: "",
                      block: "",
                    },
                  },
                  [
                    _c("date-picker-dropdown", {
                      attrs: {
                        type: "date",
                        value: _vm.form.date,
                        max: _vm.today,
                      },
                      on: {
                        input: function ($event) {
                          _vm.form.date = $event
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        value: _vm.form.date,
                                        rules: [
                                          _vm.required(_vm.$t("field.date")),
                                        ],
                                        readonly: "",
                                        "hide-details": "auto",
                                        "data-testid": "capture_date",
                                      },
                                    },
                                    "text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "form-field",
                  {
                    attrs: {
                      label: _vm.$t("field.count"),
                      required: "",
                      block: "",
                    },
                  },
                  [
                    _c("text-field", {
                      attrs: {
                        type: "number",
                        rules: _vm.countRules,
                        "hide-details": "auto",
                        "data-testid": "capture_count",
                      },
                      model: {
                        value: _vm.form.count,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "count", _vm._n($$v))
                        },
                        expression: "form.count",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "form-field",
                  {
                    attrs: {
                      label: _vm.$t("field.species"),
                      required: "",
                      block: "",
                    },
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        items: _vm.speciesOptions,
                        rules: [_vm.required(_vm.$t("field.species"))],
                        dense: "",
                        outlined: "",
                        "hide-details": "auto",
                        "data-testid": "capture_species",
                      },
                      model: {
                        value: _vm.form.species,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "species", $$v)
                        },
                        expression: "form.species",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "editor-divider",
                  attrs: { role: "separator" },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "editor-optional-row" },
                  [
                    _c(
                      "form-field",
                      {
                        attrs: { label: _vm.$t("field.trap_type"), block: "" },
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.trapTypeOptions,
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            clearable: "",
                            "data-testid": "capture_trap_type",
                          },
                          model: {
                            value: _vm.form.trap_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "trap_type", $$v)
                            },
                            expression: "form.trap_type",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "form-field",
                      {
                        attrs: {
                          label: _vm.$t("field.growth_stage"),
                          block: "",
                        },
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.growthStageOptions,
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            clearable: "",
                            "data-testid": "capture_growth_stage",
                          },
                          model: {
                            value: _vm.form.growth_stage,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "growth_stage", $$v)
                            },
                            expression: "form.growth_stage",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "form-field",
                      { attrs: { label: _vm.$t("field.sex"), block: "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.sexOptions,
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            clearable: "",
                            "data-testid": "capture_sex",
                          },
                          model: {
                            value: _vm.form.sex,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sex", $$v)
                            },
                            expression: "form.sex",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "form-field",
                  { attrs: { label: _vm.$t("field.memo"), block: "" } },
                  [
                    _c("v-textarea", {
                      staticClass: "memo-area",
                      attrs: {
                        "no-resize": "",
                        dense: "",
                        outlined: "",
                        "hide-details": "",
                        "data-testid": "capture_memo",
                      },
                      model: {
                        value: _vm.form.memo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "memo", $$v)
                        },
                        expression: "form.memo",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "aside",
              {
                staticClass: "mp-sidebar",
                attrs: { "aria-label": _vm.$mpt(_vm.$t("field.sensors")) },
              },
              [
                _c(
                  "div",
                  { staticClass: "mp-sidebar__inner" },
                  [
                    _c("span", { staticClass: "mp-sidebar__label" }, [
                      _vm._v(_vm._s(_vm.$mpt(_vm.$t("field.sensors")))),
                    ]),
                    _vm._v(" "),
                    _c("monitoring-point-selector", {
                      staticClass: "mp-selector",
                      attrs: {
                        sensors: _vm.sensors,
                        "orphaned-sensor-ids": _vm.orphanedSensorIds,
                        visible: _vm.value,
                      },
                      model: {
                        value: _vm.form.sensor_ids,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sensor_ids", $$v)
                        },
                        expression: "form.sensor_ids",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }